import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { CTASection } from '../components/CTASection';
import { CheckCircle2 } from 'lucide-react';
export function AboutPage() {
  return <div className="flex flex-col w-full" data-id="element-175" data-mp="55a9nt14u96k">
      <HeroBanner title="ABOUT US" subtitle="Orange County's trusted seamless rain gutter professionals since 2010." data-id="element-176" data-mp="548vvgsqf8l5" />

      <section className="py-20 px-4 bg-white" data-id="element-177" data-mp="3rcs32ddjed5n">
        <div className="max-w-7xl mx-auto" data-id="element-178" data-mp="3relavvzvz3f8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-179" data-mp="3mdxawktojc8v">
            <div data-id="element-180" data-mp="3mg1l1ki697hl">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-6" data-id="element-181" data-mp="3icby0zh5axyo">
                Committed to Protecting Your Home
              </h2>
              <div className="space-y-6 text-slate-600 text-lg" data-id="element-182" data-mp="3detq9cev6os9">
                <p data-id="element-183" data-mp="1glie6004jukv">
                  At A-Flow Seamless Rain Gutters, we understand that your home
                  is your most valuable asset. Proper water management is
                  critical to protecting its foundation, siding, and landscaping
                  from costly water damage.
                </p>
                <p data-id="element-184" data-mp="2jwdg3nnhhzwt">
                  As a locally owned and operated business in Orange County, we
                  take pride in delivering exceptional craftsmanship and
                  unparalleled customer service. We specialize in
                  custom-fabricated seamless aluminum and copper gutters that
                  not only function flawlessly but also enhance the
                  architectural beauty of your home.
                </p>
                <p data-id="element-185" data-mp="2oueuvwdvnd2h">
                  Our team of experienced installers treats every home as if it
                  were their own, ensuring precise measurements, secure
                  installations, and a clean workspace when the job is done.
                </p>
              </div>

              <div className="mt-10 space-y-4" data-id="element-186" data-mp="3hh7ycminiqg6">
                {['Fully Licensed, Bonded, and Insured', 'Premium Materials (Aluminum & Copper)', 'Custom On-Site Fabrication', '100% Satisfaction Guarantee'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-187" data-mp="3m7bue7gj80ku" data-mpi={i}>
                    <CheckCircle2 className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-188" data-mp="3m9ofuuli0t2n" />
                    <span className="font-medium text-slate-800" data-id="element-189" data-mp="3h7z93r5b71kd">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="relative" data-id="element-190" data-mp="38fnfjwewey06">
              <div className="aspect-square w-full rounded-2xl bg-slate-100 border border-slate-200 shadow-inner flex flex-col items-center justify-center p-12 text-center" data-id="element-191" data-mp="38em77zp9opm5">
                <div className="w-24 h-24 bg-[#0c2340] rounded-full flex items-center justify-center mb-6" data-id="element-192" data-mp="2yj2bpeem7sxx">
                  <span className="text-3xl font-bold text-white" data-id="element-193" data-mp="2thmpvk4m5ieh">10+</span>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-194" data-mp="2pim9075p4pu4">
                  Years of Excellence
                </h3>
                <p className="text-slate-500" data-id="element-195" data-mp="151d40rwik2ed">
                  Serving Orange County and surrounding areas with top-tier
                  gutter solutions.
                </p>
              </div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#b87333]/10 rounded-full -z-10" data-id="element-196" data-mp="1dxvt1t1mj65o" />
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#0c2340]/10 rounded-full -z-10" data-id="element-197" data-mp="1iwyxbb9s58cl" />
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-198" data-mp="qb5tqzgntpor" />
    </div>;
}